import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'

import './styles/fonts.css'
import './styles/tokens.css'
import './styles/base.css'
import './styles/prose.css'
import './styles/site.css'
import './styles/player.css'
import './styles/admin.css'

const container = document.getElementById('root')
if (!container) throw new Error('Missing #root element')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
